import script from "./UCEntitySelection.vue?vue&type=script&setup=true&lang=js"
export * from "./UCEntitySelection.vue?vue&type=script&setup=true&lang=js"

import "./UCEntitySelection.vue?vue&type=style&index=0&id=3f6f7e60&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f6f7e60"]])

export default __exports__